// extracted by mini-css-extract-plugin
export default {"bestdata_count":"BestData_bestdata_count__VlNn9","bestdata_subject":"BestData_bestdata_subject__M4crS"};